import { useFormContext } from "react-hook-form";
import CotationCard from "./CotationCard";
import { CotationFormData } from "../../../../types/forms/home/cotationFormData.form";
import ShipmentTransitIcon from "../../../../assets/icons/shipment-transit.svg?react";
import StyledSwitch from "../../../../components/ui/customs/StyledSwitch";

const ExpressCard = () => {
  const { control } = useFormContext<CotationFormData>();

  return (
    <CotationCard>
      <div className="flex flex-1 flex-row gap-4">
        <ShipmentTransitIcon className="text-zinc-900" />
        <div className="flex flex-1 flex-col">
          <p className="font-semibold">Express</p>
          <p>Livraison 24h/48h, traitement prioritaire en douane et par l’équipe Pelican</p>
        </div>
        <StyledSwitch name="express" control={control} />
      </div>
    </CotationCard>
  );
};

export default ExpressCard;
